/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PlacementHint.vue?vue&type=template&id=34158432&scoped=true"
import script from "./PlacementHint.vue?vue&type=script&lang=js"
export * from "./PlacementHint.vue?vue&type=script&lang=js"
import style0 from "./PlacementHint.vue?vue&type=style&index=0&id=34158432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34158432",
  null
  
)

export default component.exports